'use strict';

var _plugins = require('./plugins');


/*****************
 ** WEBPACK FOOTER
 ** ./~/radium/lib/config.js
 ** module id = 8
 ** module chunks = 0
 **/